import React, { Component } from 'react';
import { navigate, Link } from '@reach/router'; 
import { withFirebase } from '../components/Firebase';



class Budget extends Component {
  constructor(props) {
    super(props)

    this.state = {
      budget: 0.00 || 0.00
    }
  }

  setBudget = (e) => {
    const newBudget = this.state.budget;
    const userRef = this.props.firebase.user(this.props.user);
    userRef.update({ budget: Number(newBudget) })
    navigate('/')
    e.preventDefault()
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div id="budget-page">
        <div className="left">
          <div>
            <div id="flexed" className="logo">
              <Link to='/'><img className="back-button" src="./img/back.svg" alt="back button" /></Link>
              <h1><img src='./img/logo.svg' alt="logo"></img></h1>
              <div className="spacer"></div>
            </div>
            <h2>Welcome!</h2>
            <p>We track your budget using a daily, weekly, and monthly amount. 
               This should be the amount of 'extra' money available after all of your bills are paid.</p>
            <p>We will set up your budget using a weekly amount.</p>
            <h2>Set your budget!</h2>
            <form className="form-container" onSubmit={this.setBudget}>
              <label htmlFor="budget">Weekly</label>
              <input id="budget" name="budget"  type="number" step="0.01" onChange={this.onChange} label="Amount Spent" placeholder="$0.00" inputMode="decimal" ></input>
              <button className="dark" onClick={this.setBudget}>Set Budget</button>
            </form>
            <p>Monthly: <span>{(this.state.budget * 4).toFixed(2)}</span></p>
            <p>Weekly: <span>{this.state.budget}</span></p>
            <p>Daily: <span>{(this.state.budget / 7).toFixed(2)}</span></p>
            {/* <div className="image"><img src='./img/rain.svg' alt="make it rain cash"></img></div> */}
          </div>
        </div>
      </div>
    )
  }
}

export default withFirebase(Budget);